export { default as DocumentArchiveSolidIcon } from './DocumentArchiveSolidIcon';
